import { injectable } from "tsyringe";
import { VeraChat } from "src/shared/services/chat/vera/vera-chat";
import { CrmChat } from "src/shared/services/chat/crm/crm.chat";

type VoidPromise = Promise<void>;

export enum ChatProviders {
    Crm = "CRM",
    Whatsapp = "Whatsapp",
}

export interface Chat {
    show: () => VoidPromise;
    hide: () => VoidPromise;
    shouldShow: () => boolean;
}

@injectable()
export class ChatService {
    static createChat(provider: ChatProviders): Chat {
        if (provider === ChatProviders.Crm) {
            return new CrmChat();
        }
        if (provider === ChatProviders.Whatsapp) {
            return new VeraChat();
        }
        throw new Error("No provider found");
    }
}
